import type { RootState } from 'js/src/libs/RootState';

function _getVideo(state: RootState) {
    return state.undoable.present.video;
}

export function getBrandKitId(state: RootState) {
    return _getVideo(state).brand_kit_id;
}
